import React from 'react';
import './UserListModal.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

const getMediaUrl = (key: string | null | undefined): string | null => {
  if (!key) return null;
  if (key.startsWith('http')) return key;
  return `${BACKEND_URL}/uploads/${key}`;
};

export interface UserListModalUser {
  id: number;
  name: string;
  email: string;
  city?: string | null;
  state?: string | null;
  roles?: string[];
  profile_picture?: string | null;
}

interface UserListModalProps {
  title: string;
  users: UserListModalUser[];
  loading: boolean;
  onClose: () => void;
  onUserClick?: (userId: number) => void;
}

const UserListModal: React.FC<UserListModalProps> = ({
  title,
  users,
  loading,
  onClose,
  onUserClick,
}) => (
  <div className="ulm-overlay" onClick={onClose}>
    <div className="ulm-modal" onClick={e => e.stopPropagation()}>
      <div className="ulm-header">
        <h3>{title}</h3>
        <button className="ulm-close-btn" onClick={onClose} aria-label="Close">✕</button>
      </div>
      <div className="ulm-body">
        {loading ? (
          <div className="ulm-loading">Loading…</div>
        ) : users.length === 0 ? (
          <div className="ulm-empty">No users found.</div>
        ) : (
          <div className="ulm-list">
            {users.map((user) => {
              const avatar = getMediaUrl(user.profile_picture);
              const ItemElement = onUserClick ? 'button' : 'div';
              return (
                <ItemElement
                  key={user.id}
                  {...(onUserClick ? { type: 'button', onClick: () => onUserClick(user.id) } : {})}
                  className={`ulm-item${onUserClick ? '' : ' ulm-item--static'}`}
                >
                  <div className="ulm-item-avatar">
                    {avatar ? <img src={avatar} alt={user.name} /> : <span>{user.name.charAt(0).toUpperCase()}</span>}
                  </div>
                  <div className="ulm-item-content">
                    <span className="ulm-item-name">{user.name}</span>
                    <span className="ulm-item-email">{user.email}</span>
                    {(user.city || user.state || (user.roles?.length ?? 0) > 0) && (
                      <span className="ulm-item-meta">
                        {[user.city, user.state].filter(Boolean).join(', ')}
                        {user.roles && user.roles.length > 0 ? ` • ${user.roles.slice(0, 2).join(' · ')}` : ''}
                      </span>
                    )}
                  </div>
                </ItemElement>
              );
            })}
          </div>
        )}
      </div>
    </div>
  </div>
);

export default UserListModal;
